import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { notify } from '../utils/notify';
import '../styles/bpo.css';

// Módulos liberáveis por cliente (devem bater com as colunas mod_* da tabela clientes_bpo
// e com os botões do DashboardCliente.js)
const MODULOS = [
  { key: 'mod_projetos', label: 'Projetos', icon: 'fa-project-diagram' },
  { key: 'mod_saving', label: 'Saving', icon: 'fa-piggy-bank' },
  { key: 'mod_projecao_orcamentaria', label: 'Projeção Orçamentária', icon: 'fa-chart-pie' },
  { key: 'mod_dre_vertical', label: 'DRE Vertical', icon: 'fa-file-alt' },
  { key: 'mod_dre_horizontal', label: 'DRE Horizontal', icon: 'fa-table-cells' },
  { key: 'mod_contas_pagar', label: 'Contas a Pagar', icon: 'fa-file-invoice-dollar' },
  { key: 'mod_contas_receber', label: 'Contas a Receber', icon: 'fa-hand-holding-usd' },
  { key: 'mod_posicao', label: 'Posição Financeira', icon: 'fa-chart-pie' },
  { key: 'mod_fechamento', label: 'Fechamento', icon: 'fa-calculator' },
  { key: 'mod_envio_notas', label: 'Envio de Notas', icon: 'fa-envelope-open-text' },
];

const ClientesBpo = () => {
  const navigate = useNavigate();
  const [clientes, setClientes] = useState([]);
  const [operadores, setOperadores] = useState([]);
  const [carregando, setCarregando] = useState(false);
  const [mensagem, setMensagem] = useState({ tipo: '', texto: '' });

  // Ponte para toasts (react-toastify): dispara o toast conforme o tipo da mensagem
  useEffect(() => {
    if (!mensagem.texto) return;
    if (mensagem.tipo === 'success') notify.sucesso(mensagem.texto);
    else if (mensagem.tipo === 'warning') notify.aviso(mensagem.texto);
    else if (mensagem.tipo === 'danger') notify.erro(mensagem.texto);
    else notify.info(mensagem.texto);
  }, [mensagem]);

  const [modalAberto, setModalAberto] = useState(false);
  const [editando, setEditando] = useState(null);
  const [modalVisualizarAberto, setModalVisualizarAberto] = useState(false);
  const [clienteSelecionado, setClienteSelecionado] = useState(null);

  // Gestão de módulos por cliente
  const [modalModulosAberto, setModalModulosAberto] = useState(false);
  const [clienteModulos, setClienteModulos] = useState(null);
  const [modulosForm, setModulosForm] = useState({});
  const [salvandoModulos, setSalvandoModulos] = useState(false);

  // Situação FMP (acompanhamento de onboarding/entrega por cliente)
  const [situacaoFmp, setSituacaoFmp] = useState([]);
  const [carregandoSituacao, setCarregandoSituacao] = useState(false);
  const [devolutivasRascunho, setDevolutivasRascunho] = useState({}); // id -> texto em edição (antes do blur)
  const [modalDevolutivaAberto, setModalDevolutivaAberto] = useState(false);
  const [devolutivaSelecionada, setDevolutivaSelecionada] = useState(null); // { id, nome, texto }
  const [salvandoDevolutivaModal, setSalvandoDevolutivaModal] = useState(false);

  // Filtros da tabela Situação FMP
  const [filtroSituacaoTexto, setFiltroSituacaoTexto] = useState('');
  const [filtroSituacaoOperador, setFiltroSituacaoOperador] = useState('');
  const [filtroSituacaoSistema, setFiltroSituacaoSistema] = useState('');
  const [filtroSituacaoStatus, setFiltroSituacaoStatus] = useState(''); // '' | 'completo' | 'pendente'

  const CAMPOS_STATUS_FMP = ['chave_api', 'entregue_operador', 'reuniao_apresentacao', 'cliente_com_acesso', 'envio_posicao', 'envio_fechamento'];

  // Quantos dias se passaram desde a Data de Entrega ('dd/mm/aaaa'). Usado para mostrar
  // há quanto tempo um cliente pendente (nem tudo "Sim") foi entregue, e ainda não avançou.
  const calcularDiasPendente = (dataStr) => {
    if (!dataStr) return null;
    const [dia, mes, ano] = dataStr.split('/').map(Number);
    if (!dia || !mes || !ano) return null;
    const dataEntrega = new Date(ano, mes - 1, dia);
    const hoje = new Date();
    hoje.setHours(0, 0, 0, 0);
    dataEntrega.setHours(0, 0, 0, 0);
    const dias = Math.floor((hoje - dataEntrega) / (1000 * 60 * 60 * 24));
    return dias >= 0 ? dias : null;
  };

  // Valor usado para ORDENAR: clientes completos (ou sem data de entrega) vão para o fim da lista
  const diasPendenteParaOrdenar = (s) => {
    const completo = CAMPOS_STATUS_FMP.every((campo) => s[campo] === 'Sim');
    if (completo) return -1;
    const dias = calcularDiasPendente(s.data_entrega);
    return dias === null ? -1 : dias;
  };

  const operadoresSituacaoUnicos = Array.from(new Set(situacaoFmp.map(s => s.operador).filter(Boolean))).sort();
  const sistemasSituacaoUnicos = Array.from(new Set(situacaoFmp.map(s => s.sistema).filter(Boolean))).sort();

  const situacaoFmpFiltrada = situacaoFmp
    .filter(s => !filtroSituacaoTexto || (s.nome || '').toLowerCase().includes(filtroSituacaoTexto.toLowerCase()))
    .filter(s => !filtroSituacaoOperador || s.operador === filtroSituacaoOperador)
    .filter(s => !filtroSituacaoSistema || s.sistema === filtroSituacaoSistema)
    .filter(s => {
      if (!filtroSituacaoStatus) return true;
      const completo = CAMPOS_STATUS_FMP.every((campo) => s[campo] === 'Sim');
      return filtroSituacaoStatus === 'completo' ? completo : !completo;
    })
    .slice()
    .sort((a, b) => diasPendenteParaOrdenar(b) - diasPendenteParaOrdenar(a));

  const [formData, setFormData] = useState({
    nome: '',
    cnpj: '',
    mensalidade: '',
    nome_operador: '',
    email: '',
    regime_tributario: '',
    operador_dp: '',
    operador_contabil: '',
    operador_fiscal: '',
    link_drive: '',
    email_contabilidade: '',
    email_fiscal: '',
    ativo: 'Sim',
    database: '',
    sistema: '',
    apikey: '',
    apisecredty: '',
    email_operador: '',
    senha_app_operador: '',
    operador_bpo_id: '',
    id_empresa_ca: '',
    url_atualizacao: '',
    tipo_plano: '',
    dia_posicao: '',
    dia_fechamento: ''
  });

  // Operadores de envio (tabela operadores_bpo): a credencial fica cadastrada uma
  // vez e o cliente só aponta. A senha nunca volta do backend — só `tem_senha`.
  const [operadoresEnvio, setOperadoresEnvio] = useState([]);
  const [modalOperadores, setModalOperadores] = useState(false);
  const [formOperador, setFormOperador] = useState({ id: null, nome: '', email: '', senha_app: '', ativo: 'Sim', observacao: '' });
  const [salvandoOperador, setSalvandoOperador] = useState(false);

  const carregarOperadoresEnvio = async () => {
    try {
      const token = localStorage.getItem('access');
      const r = await axios.get(
        `${process.env.REACT_APP_API_BASE}/api/operadores-envio/`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      if (r.data?.success) setOperadoresEnvio(r.data.operadores || []);
    } catch (e) {
      // lista vazia: o select mostra o aviso de cadastrar
    }
  };

  const salvarOperadorEnvio = async () => {
    if (!formOperador.nome.trim() || !formOperador.email.trim()) {
      alert('Informe nome e e-mail do operador.');
      return;
    }
    setSalvandoOperador(true);
    try {
      const token = localStorage.getItem('access');
      const cfg = { headers: { Authorization: `Bearer ${token}` } };
      const corpo = {
        nome: formOperador.nome.trim(),
        email: formOperador.email.trim(),
        senha_app: formOperador.senha_app,
        ativo: formOperador.ativo,
        observacao: formOperador.observacao,
      };
      const r = formOperador.id
        ? await axios.put(`${process.env.REACT_APP_API_BASE}/api/operadores-envio/${formOperador.id}/`, corpo, cfg)
        : await axios.post(`${process.env.REACT_APP_API_BASE}/api/operadores-envio/`, corpo, cfg);
      if (r.data?.success) {
        setFormOperador({ id: null, nome: '', email: '', senha_app: '', ativo: 'Sim', observacao: '' });
        carregarOperadoresEnvio();
      } else {
        alert(r.data?.mensagem || 'Falha ao salvar operador.');
      }
    } catch (e) {
      alert(e.response?.data?.mensagem || 'Erro ao salvar operador.');
    } finally {
      setSalvandoOperador(false);
    }
  };

  const removerOperadorEnvio = async (op) => {
    if (!window.confirm(`Remover o operador ${op.nome}?`)) return;
    try {
      const token = localStorage.getItem('access');
      const r = await axios.delete(
        `${process.env.REACT_APP_API_BASE}/api/operadores-envio/${op.id}/`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      if (r.data?.success) carregarOperadoresEnvio();
      else alert(r.data?.mensagem || 'Não foi possível remover.');
    } catch (e) {
      alert(e.response?.data?.mensagem || 'Erro ao remover operador.');
    }
  };

  useEffect(() => {
    carregarOperadoresEnvio();
    carregarClientes();
    carregarOperadores();
    carregarSituacaoFmp();
  }, []);

  const carregarOperadores = async () => {
    try {
      const token = localStorage.getItem('access');
      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE}/api/clientes-bpo/operadores/`,
        { headers: { 'Authorization': `Bearer ${token}` } }
      );
      if (response.data.success) {
        setOperadores(response.data.operadores);
      }
    } catch (error) {
      console.error('Erro ao carregar operadores:', error);
    }
  };

  const carregarClientes = async () => {
    setCarregando(true);
    try {
      const token = localStorage.getItem('access');
      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE}/api/clientes-bpo/`,
        {
          headers: { 'Authorization': `Bearer ${token}` }
        }
      );

      if (response.data.success) {
        setClientes(response.data.dados);
      }
    } catch (error) {
      mostrarMensagem('danger', 'Erro ao carregar clientes');
    } finally {
      setCarregando(false);
    }
  };

  const abrirModalVisualizar = (cliente) => {
    setClienteSelecionado(cliente);
    setModalVisualizarAberto(true);
    document.body.classList.add('modal-open');
  };

  const fecharModalVisualizar = () => {
    setModalVisualizarAberto(false);
    setClienteSelecionado(null);
    document.body.classList.remove('modal-open');
  };

  const mostrarMensagem = (tipo, texto) => {
    setMensagem({ tipo, texto });
    setTimeout(() => setMensagem({ tipo: '', texto: '' }), 4000);
  };

  const getUsuarioLogado = () => {
    try {
      const token = localStorage.getItem('access');
      if (!token) return null;
      const payload = JSON.parse(atob(token.split('.')[1]));
      return (payload.first_name || payload.username || '').toLowerCase();
    } catch {
      return null;
    }
  };

  const acessarAreaCliente = (cliente) => {
  if (cliente.id === 19) {
    const usuario = getUsuarioLogado();

    if (!usuario || (!usuario.includes('eleandro') && !usuario.includes('kelen') && !usuario.includes('machado') && !usuario.includes('yasmin'))) {
      mostrarMensagem('danger', 'Acesso restrito. ');
      return;
    }
  }


    if (cliente.sistema === 'conta_azul') {
      navigate(`/dashboard-conta-azul/${cliente.id}`);
    } else {
      navigate(`/dashboard-cliente/${cliente.id}`);
    }

    mostrarMensagem('success', `Acessando área do cliente: ${cliente.nome}`);
  };

  const abrirLinkDrive = (cliente) => {
    if (cliente.link_drive) {
      window.open(cliente.link_drive, '_blank', 'noopener,noreferrer');
    } else {
      mostrarMensagem('warning', `Nenhum link do Google Drive cadastrado para "${cliente.nome}"`);
    }
  };

  const abrirModal = (cliente = null) => {
    if (cliente) {
      setEditando(cliente.id);
      setFormData({
        nome: cliente.nome,
        cnpj: formatarCNPJ(cliente.cnpj),
        mensalidade: cliente.mensalidade,
        nome_operador: cliente.nome_operador || '',
        email: cliente.email || '',
        regime_tributario: cliente.regime_tributario || '',
        operador_dp: cliente.operador_dp || '',
        operador_contabil: cliente.operador_contabil || '',
        operador_fiscal: cliente.operador_fiscal || '',
        link_drive: cliente.link_drive || '',
        email_contabilidade: cliente.email_contabilidade || '',
        email_fiscal: cliente.email_fiscal || '',
        ativo: cliente.ativo,
        database: cliente.database || '',
        sistema: cliente.sistema || '',
        apikey: cliente.apikey || '',
        apisecredty: cliente.apisecredty || '',
        email_operador: cliente.email_operador || '',
        senha_app_operador: cliente.senha_app_operador || '',
        operador_bpo_id: cliente.operador_bpo_id || '',
        id_empresa_ca: cliente.id_empresa_ca || '',
        url_atualizacao: cliente.url_atualizacao || '',
        tipo_plano: cliente.tipo_plano || '',
        dia_posicao: cliente.dia_posicao || '',
        dia_fechamento: cliente.dia_fechamento || ''
      });
    } else {
      setEditando(null);
      setFormData({
        nome: '',
        cnpj: '',
        mensalidade: '',
        nome_operador: '',
        email: '',
        regime_tributario: '',
        operador_dp: '',
        operador_contabil: '',
        operador_fiscal: '',
        link_drive: '',
        email_contabilidade: '',
        email_fiscal: '',
        ativo: 'Sim',
        database: '',
        sistema: '',
        apikey: '',
        apisecredty: '',
        email_operador: '',
        senha_app_operador: '',
      operador_bpo_id: '',
        id_empresa_ca: '',
        url_atualizacao: '',
        tipo_plano: '',
        dia_posicao: '',
        dia_fechamento: ''
      });
    }
    setModalAberto(true);
    document.body.classList.add('modal-open');
  };

  const fecharModal = () => {
    setModalAberto(false);
    setEditando(null);
    setFormData({
      nome: '',
      cnpj: '',
      mensalidade: '',
      nome_operador: '',
      email: '',
      regime_tributario: '',
      operador_dp: '',
      operador_contabil: '',
      operador_fiscal: '',
      link_drive: '',
      email_contabilidade: '',
      email_fiscal: '',
      ativo: 'Sim',
      database: '',
      sistema: '',
      apikey: '',
      apisecredty: '',
      email_operador: '',
      senha_app_operador: '',
      operador_bpo_id: '',
      id_empresa_ca: '',
      url_atualizacao: '',
      tipo_plano: '',
      dia_posicao: '',
      dia_fechamento: ''
    });
    document.body.classList.remove('modal-open');
  };

  const formatarCNPJ = (cnpj) => {
    const numeros = cnpj.replace(/\D/g, '');
    if (numeros.length === 14) {
      return numeros.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5');
    }
    return cnpj;
  };

  const handleCNPJChange = (e) => {
    let valor = e.target.value.replace(/\D/g, '');
    if (valor.length <= 14) {
      if (valor.length === 14) {
        valor = valor.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5');
      }
      setFormData({ ...formData, cnpj: valor });
    }
  };

  const salvarCliente = async () => {
    if (!formData.nome || !formData.cnpj || formData.mensalidade === '') {
      mostrarMensagem('warning', 'Preencha todos os campos obrigatórios');
      return;
    }

    const validarEmails = (emailString) => {
      if (!emailString || emailString.trim() === '') return true;

      const emails = emailString.split(';').map(email => email.trim()).filter(email => email !== '');
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

      return emails.every(email => emailRegex.test(email));
    };

    if (formData.email && !validarEmails(formData.email)) {
      mostrarMensagem('warning', 'Email inválido. Use ponto e vírgula (;) para separar múltiplos emails');
      return;
    }

    if (formData.email_contabilidade && !validarEmails(formData.email_contabilidade)) {
      mostrarMensagem('warning', 'Email da contabilidade inválido. Use ponto e vírgula (;) para separar múltiplos emails');
      return;
    }

    if (formData.email_fiscal && !validarEmails(formData.email_fiscal)) {
      mostrarMensagem('warning', 'Email fiscal inválido. Use ponto e vírgula (;) para separar múltiplos emails');
      return;
    }

    setCarregando(true);
    try {
      const token = localStorage.getItem('access');
      const url = editando
        ? `${process.env.REACT_APP_API_BASE}/api/clientes-bpo/${editando}/editar/`
        : `${process.env.REACT_APP_API_BASE}/api/clientes-bpo/cadastrar/`;

      const method = editando ? 'put' : 'post';

      const response = await axios[method](url, formData, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });

      if (response.data.success) {
        mostrarMensagem('success', response.data.mensagem);
        fecharModal();
        carregarClientes();
      }
    } catch (error) {
      const errorMsg = error.response?.data?.mensagem || 'Erro ao salvar cliente';
      mostrarMensagem('danger', errorMsg);
    } finally {
      setCarregando(false);
    }
  };

  const inativarCliente = async (id, nome) => {
    if (!window.confirm(`Tem certeza que deseja inativar o cliente "${nome}"?`)) {
      return;
    }

    setCarregando(true);
    try {
      const token = localStorage.getItem('access');
      const response = await axios.put(
        `${process.env.REACT_APP_API_BASE}/api/clientes-bpo/${id}/inativar/`,
        {},
        { headers: { 'Authorization': `Bearer ${token}` } }
      );

      if (response.data.success) {
        mostrarMensagem('success', 'Cliente inativado com sucesso');
        carregarClientes();
      }
    } catch (error) {
      mostrarMensagem('danger', 'Erro ao inativar cliente');
    } finally {
      setCarregando(false);
    }
  };

  // ========================================
  // GESTÃO DE MÓDULOS POR CLIENTE
  // ========================================
  const abrirModalModulos = (cliente) => {
    setClienteModulos(cliente);
    const inicial = {};
    MODULOS.forEach(m => { inicial[m.key] = cliente[m.key] === 'Não' ? 'Não' : 'Sim'; });
    setModulosForm(inicial);
    setModalModulosAberto(true);
    document.body.classList.add('modal-open');
  };

  const fecharModalModulos = () => {
    setModalModulosAberto(false);
    setClienteModulos(null);
    setModulosForm({});
    document.body.classList.remove('modal-open');
  };

  const toggleModulo = (key) => {
    setModulosForm(prev => ({ ...prev, [key]: prev[key] === 'Sim' ? 'Não' : 'Sim' }));
  };

  const definirTodosModulos = (valor) => {
    const novo = {};
    MODULOS.forEach(m => { novo[m.key] = valor; });
    setModulosForm(novo);
  };

  const salvarModulos = async () => {
    if (!clienteModulos) return;
    setSalvandoModulos(true);
    try {
      const token = localStorage.getItem('access');
      const response = await axios.put(
        `${process.env.REACT_APP_API_BASE}/api/clientes-bpo/${clienteModulos.id}/modulos/`,
        modulosForm,
        { headers: { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' } }
      );
      if (response.data.success) {
        mostrarMensagem('success', response.data.mensagem || 'Módulos atualizados com sucesso');
        fecharModalModulos();
        carregarClientes();
      } else {
        mostrarMensagem('danger', response.data.mensagem || 'Erro ao salvar módulos');
      }
    } catch (error) {
      mostrarMensagem('danger', error.response?.data?.mensagem || 'Erro ao salvar módulos');
    } finally {
      setSalvandoModulos(false);
    }
  };

  // ========================================
  // SITUAÇÃO FMP (acompanhamento de onboarding/entrega)
  // ========================================
  const carregarSituacaoFmp = async () => {
    setCarregandoSituacao(true);
    try {
      const token = localStorage.getItem('access');
      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE}/api/situacao-fmp/`,
        { headers: { 'Authorization': `Bearer ${token}` } }
      );
      if (response.data.success) {
        setSituacaoFmp(response.data.dados);
      }
    } catch (error) {
      console.error('Erro ao carregar situação FMP:', error);
    } finally {
      setCarregandoSituacao(false);
    }
  };

  // Atualização otimista: aplica na UI na hora e salva no backend em seguida
  const atualizarSituacaoFmp = async (id, campo, valor) => {
    setSituacaoFmp(prev => prev.map(s => (s.id === id ? { ...s, [campo]: valor } : s)));
    try {
      const token = localStorage.getItem('access');
      const response = await axios.put(
        `${process.env.REACT_APP_API_BASE}/api/situacao-fmp/${id}/editar/`,
        { [campo]: valor },
        { headers: { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' } }
      );
      if (!response.data.success) {
        mostrarMensagem('danger', response.data.mensagem || 'Erro ao atualizar situação FMP');
      }
    } catch (error) {
      mostrarMensagem('danger', error.response?.data?.mensagem || 'Erro ao atualizar situação FMP');
    }
  };

  // Devolutiva do Cliente: texto livre, salvo ao sair do campo (blur) para não gerar 1 request por tecla
  const handleDevolutivaChange = (id, valor) => {
    setDevolutivasRascunho(prev => ({ ...prev, [id]: valor }));
  };

  const salvarDevolutiva = (id) => {
    const valor = devolutivasRascunho[id];
    const atual = situacaoFmp.find(s => s.id === id);
    if (valor === undefined || valor === (atual?.devolutiva_cliente || '')) return;
    atualizarSituacaoFmp(id, 'devolutiva_cliente', valor);
  };

  // Ver/editar a devolutiva já registrada, em um modal (a célula só mostra um ícone de olho)
  const abrirModalDevolutiva = (situacao) => {
    setDevolutivaSelecionada({ id: situacao.id, nome: situacao.nome, texto: situacao.devolutiva_cliente || '' });
    setModalDevolutivaAberto(true);
    document.body.classList.add('modal-open');
  };

  const fecharModalDevolutiva = () => {
    setModalDevolutivaAberto(false);
    setDevolutivaSelecionada(null);
    document.body.classList.remove('modal-open');
  };

  const salvarDevolutivaModal = async () => {
    if (!devolutivaSelecionada) return;
    setSalvandoDevolutivaModal(true);
    await atualizarSituacaoFmp(devolutivaSelecionada.id, 'devolutiva_cliente', devolutivaSelecionada.texto);
    setSalvandoDevolutivaModal(false);
    fecharModalDevolutiva();
  };

  const deletarSituacaoFmp = async (id, nome) => {
    if (!window.confirm(`Tem certeza que deseja remover "${nome}" da Situação FMP?\n\nEsta ação não pode ser desfeita.`)) {
      return;
    }
    try {
      const token = localStorage.getItem('access');
      const response = await axios.delete(
        `${process.env.REACT_APP_API_BASE}/api/situacao-fmp/${id}/deletar/`,
        { headers: { 'Authorization': `Bearer ${token}` } }
      );
      if (response.data.success) {
        mostrarMensagem('success', response.data.mensagem || 'Registro removido com sucesso');
        setSituacaoFmp(prev => prev.filter(s => s.id !== id));
      } else {
        mostrarMensagem('danger', response.data.mensagem || 'Erro ao remover registro');
      }
    } catch (error) {
      mostrarMensagem('danger', error.response?.data?.mensagem || 'Erro ao remover registro');
    }
  };

  return (
    <div className="das-page bpo-page">
      <div className="container-fluid px-4 mt-5">
        <div className="bpo-shell">
          <div className="bpo-head bpo-in" style={{ '--i': 0 }}>
            <div className="d-flex align-items-center">
              <i className="fas fa-users header-icon me-3"></i>
              <div>
                <h2 className="titulo-pagina m-0">Empresas BPO</h2>
                <p className="bpo-head-sub">
                  Cadastro, módulos e credenciais de envio de cada empresa atendida.
                </p>
              </div>
            </div>
            <button
              className="btn btn-primary"
              onClick={() => abrirModal()}
              disabled={carregando}
            >
              <i className="fas fa-plus me-2"></i>
              Novo Cliente
            </button>
          </div>

          {/* Resumo no topo: antes ficava em badges no rodapé da tabela, onde
              quase ninguém rolava para ver. */}
          {clientes.length > 0 && (() => {
            const ativos = clientes.filter((c) => c.ativo === 'Sim');
            const somaAtivos = ativos.reduce((t, c) => t + (parseFloat(c.mensalidade) || 0), 0);
            const somaTodas = clientes.reduce((t, c) => t + (parseFloat(c.mensalidade) || 0), 0);
            const brl = (v) => `R$ ${parseFloat(v || 0).toLocaleString('pt-BR', { minimumFractionDigits: 2 })}`;
            const kpi = (i, icone, tom, rotulo, valor, sub) => (
              <div className={`bpo-kpi bpo-tone-${tom} bpo-in`} style={{ '--i': i }}>
                <div className="bpo-kpi-top">
                  <span className="bpo-kpi-ico"><i className={`fas ${icone}`}></i></span>
                  {rotulo}
                </div>
                <div className="bpo-kpi-value">{valor}</div>
                {sub && <div className="bpo-kpi-sub">{sub}</div>}
              </div>
            );
            return (
              <div className="bpo-kpis">
                {kpi(1, 'fa-building', 'navy', 'Empresas', clientes.length,
                     `${ativos.length} ativa(s)`)}
                {kpi(2, 'fa-coins', 'green', 'Mensalidade ativa', brl(somaAtivos),
                     `${brl(somaTodas)} incluindo inativas`)}
                {kpi(3, 'fa-chart-pie', 'cyan', 'Ticket médio',
                     brl(ativos.length ? somaAtivos / ativos.length : 0), 'Por empresa ativa')}
                {kpi(4, 'fa-paper-plane', 'gold', 'Operadores de envio', operadoresEnvio.length,
                     `${operadoresEnvio.filter((o) => o.tem_senha).length} com senha`)}
              </div>
            );
          })()}

          {/* Mensagens agora são exibidas como toast (react-toastify) */}

          <div className="table-responsive">
            {carregando && clientes.length === 0 ? (
              <div className="bpo-estado">
                <div className="spinner-border" style={{ color: '#00205b' }} role="status">
                  <span className="visually-hidden">Carregando...</span>
                </div>
                <p className="mt-3 mb-0">Carregando clientes...</p>
              </div>
            ) : clientes.length === 0 ? (
              <div className="bpo-estado">
                <i className="fas fa-users"></i>
                <p className="mb-0">Nenhum cliente cadastrado</p>
              </div>
            ) : (
              <table className="table table-bordered table-hover text-center align-middle bpo-tabela bpo-in" style={{ '--i': 5 }}>
                <thead className="table-light">
                  <tr>
                    <th style={{ width: '64px' }} title="ID do cliente na tabela clientes_bpo">ID</th>
                    <th style={{ minWidth: '250px' }}>Nome</th>
                    <th style={{ width: '160px' }}>CNPJ</th>
                    <th style={{ width: '130px' }}>Operador</th>
                    <th style={{ minWidth: '180px' }}>Email</th>
                    <th style={{ width: '140px' }}>Regime Tributário</th>
                    <th style={{ width: '120px' }}>Mensalidade</th>
                    <th style={{ width: '80px' }}>Status</th>
                    <th style={{ width: '220px' }}>Ações</th>
                  </tr>
                </thead>
                <tbody>
                  {clientes.map((cliente) => (
                    <tr key={cliente.id}>
                      <td>
                        <span className="badge bg-light text-dark bpo-id"
                              title="ID do cliente (clientes_bpo) — use este número no ID_CLIENTE dos loaders">
                          {cliente.id}
                        </span>
                      </td>
                      <td className="text-start bpo-nome">{cliente.nome}</td>
                      <td className="bpo-num">{formatarCNPJ(cliente.cnpj)}</td>
                      <td>{cliente.nome_operador || <span className="bpo-vazio">—</span>}</td>
                      <td className="text-start email-col">
                        {cliente.email
                          ? cliente.email.split(';').map((email, idx) => (
                              <div key={idx}>{email.trim()}</div>
                            ))
                          : <span className="bpo-vazio">—</span>}
                      </td>
                      <td>{cliente.regime_tributario || <span className="bpo-vazio">—</span>}</td>
                      <td className="bpo-num">
                        R$ {parseFloat(cliente.mensalidade || 0).toLocaleString('pt-BR', {minimumFractionDigits: 2})}
                      </td>
                      <td>
                        <span className={`badge ${cliente.ativo === 'Sim' ? 'bg-success' : 'bg-danger'}`}>
                          {cliente.ativo === 'Sim' ? 'Ativo' : 'Inativo'}
                        </span>
                      </td>
                      <td>
                        <div className="bpo-acoes">
                          <button
                            onClick={() => abrirModalVisualizar(cliente)}
                            className="btn btn-sm btn-info bpo-a-ver"
                            title="Visualizar dados"
                            aria-label={`Visualizar ${cliente.nome}`}
                          >
                            <i className="fas fa-eye"></i>
                          </button>

                          <button
                            onClick={() => abrirLinkDrive(cliente)}
                            className={`btn btn-sm ${cliente.link_drive ? 'btn-warning' : 'btn-outline-secondary'} bpo-a-drive`}
                            title={cliente.link_drive ? 'Abrir Google Drive' : 'Drive não cadastrado'}
                            aria-label="Google Drive"
                          >
                            <i className="fab fa-google-drive"></i>
                          </button>

                          <button
                            onClick={() => acessarAreaCliente(cliente)}
                            className="btn btn-sm btn-success bpo-a-area"
                            title="Área do cliente"
                            aria-label="Área do cliente"
                          >
                            <i className="fas fa-external-link-alt"></i>
                          </button>

                          <button
                            onClick={() => abrirModal(cliente)}
                            className="btn btn-sm btn-primary bpo-a-editar"
                            title="Editar"
                            aria-label={`Editar ${cliente.nome}`}
                          >
                            <i className="fas fa-edit"></i>
                          </button>

                          <button
                            onClick={() => abrirModalModulos(cliente)}
                            className="btn btn-sm btn-dark bpo-a-modulos"
                            title="Gerenciar módulos"
                            aria-label="Gerenciar módulos"
                          >
                            <i className="fas fa-th-large"></i>
                          </button>

                          <button
                            onClick={() => inativarCliente(cliente.id, cliente.nome)}
                            className="btn btn-sm btn-warning bpo-a-inativar"
                            title="Inativar"
                            aria-label={`Inativar ${cliente.nome}`}
                          >
                            <i className="fas fa-ban"></i>
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </div>

        </div>

        {/* Situação FMP — acompanhamento de onboarding/entrega por cliente */}
        <div className="bpo-shell mt-4">
          <div className="header-wrapper d-flex justify-content-between align-items-center mb-4">
            <div className="d-flex align-items-center">
              <i className="fas fa-clipboard-list header-icon me-2"></i>
              <h2 className="titulo-pagina m-0" style={{ fontSize: '1.4rem' }}>Situação FMP</h2>
            </div>
            <button
              className="btn btn-outline-secondary btn-sm"
              onClick={carregarSituacaoFmp}
              disabled={carregandoSituacao}
              title="Atualizar"
            >
              <i className={`fas fa-sync-alt ${carregandoSituacao ? 'fa-spin' : ''} me-2`}></i>
              Atualizar
            </button>
          </div>

          <div className="row g-2 mb-3 align-items-end">
            <div className="col-md-3">
              <label className="form-label small text-muted mb-1">Buscar por nome</label>
              <div className="input-group input-group-sm">
                <span className="input-group-text bg-white"><i className="fas fa-search text-muted"></i></span>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Nome do cliente..."
                  value={filtroSituacaoTexto}
                  onChange={(e) => setFiltroSituacaoTexto(e.target.value)}
                />
              </div>
            </div>
            <div className="col-md-3">
              <label className="form-label small text-muted mb-1">Operador</label>
              <select
                className="form-select form-select-sm"
                value={filtroSituacaoOperador}
                onChange={(e) => setFiltroSituacaoOperador(e.target.value)}
              >
                <option value="">Todos</option>
                {operadoresSituacaoUnicos.map(op => <option key={op} value={op}>{op}</option>)}
              </select>
            </div>
            <div className="col-md-3">
              <label className="form-label small text-muted mb-1">Sistema</label>
              <select
                className="form-select form-select-sm"
                value={filtroSituacaoSistema}
                onChange={(e) => setFiltroSituacaoSistema(e.target.value)}
              >
                <option value="">Todos</option>
                {sistemasSituacaoUnicos.map(sis => <option key={sis} value={sis}>{sis}</option>)}
              </select>
            </div>
            <div className="col-md-3">
              <label className="form-label small text-muted mb-1">Status</label>
              <select
                className="form-select form-select-sm"
                value={filtroSituacaoStatus}
                onChange={(e) => setFiltroSituacaoStatus(e.target.value)}
              >
                <option value="">Todos</option>
                <option value="pendente">Pendentes</option>
                <option value="completo">Completos</option>
              </select>
            </div>
          </div>

          <small className="text-muted d-block mb-2">
            Exibindo <strong>{situacaoFmpFiltrada.length}</strong> de {situacaoFmp.length} — ordenado por dias pendentes (mais atrasados primeiro)
          </small>

          <div className="table-responsive">
            {carregandoSituacao && situacaoFmp.length === 0 ? (
              <div className="text-center mt-4">
                <div className="spinner-border text-primary" role="status">
                  <span className="visually-hidden">Carregando...</span>
                </div>
                <p className="mt-2 text-muted">Carregando situação FMP...</p>
              </div>
            ) : situacaoFmp.length === 0 ? (
              <div className="text-center mt-4">
                <i className="fas fa-inbox fa-3x text-muted mb-3"></i>
                <p className="text-muted">Nenhum registro de situação FMP</p>
              </div>
            ) : situacaoFmpFiltrada.length === 0 ? (
              <div className="text-center mt-4">
                <i className="fas fa-filter fa-3x text-muted mb-3"></i>
                <p className="text-muted">Nenhum registro encontrado com os filtros atuais</p>
              </div>
            ) : (
              <table className="table table-bordered table-hover align-middle" style={{ fontSize: '0.82rem', minWidth: '1620px' }}>
                <thead className="table-light">
                  <tr>
                    <th style={{ minWidth: '220px' }} className="text-start">Nome</th>
                    <th style={{ width: '150px' }}>CNPJ</th>
                    <th style={{ width: '140px' }}>Operador</th>
                    <th style={{ width: '110px' }}>Modelo</th>
                    <th style={{ width: '150px' }}>Sistema</th>
                    <th style={{ width: '110px' }}>Chave API</th>
                    <th style={{ width: '150px' }}>Entregue Operador</th>
                    <th style={{ width: '110px' }}>Data Entrega</th>
                    <th style={{ width: '120px' }}>Dias Pendente</th>
                    <th style={{ width: '150px' }}>Reunião Apres.</th>
                    <th style={{ width: '150px' }}>Cliente c/ Acesso</th>
                    <th style={{ width: '130px' }}>Envio Posição</th>
                    <th style={{ width: '150px' }}>Envio Fechamento</th>
                    <th style={{ minWidth: '280px' }} className="text-start">Devolutiva Cliente</th>
                    <th style={{ width: '70px' }}>Ações</th>
                  </tr>
                </thead>
                <tbody>
                  {situacaoFmpFiltrada.map((s) => {
                    const todosSim = CAMPOS_STATUS_FMP.every((campo) => s[campo] === 'Sim');
                    const temDevolutiva = !!(s.devolutiva_cliente && s.devolutiva_cliente.trim());
                    return (
                      <tr key={s.id} style={todosSim ? { backgroundColor: '#eafbf1' } : undefined}>
                        <td className="text-start fw-semibold">
                          {s.nome}
                          {todosSim && (
                            <i className="fas fa-circle-check ms-2" style={{ color: '#198754' }} title="Tudo certo com este cliente"></i>
                          )}
                        </td>
                        <td>{s.cnpj || '-'}</td>
                        <td>{s.operador || '-'}</td>
                        <td>
                          <select
                            className="form-select form-select-sm"
                            style={{ backgroundColor: todosSim ? '#eafbf1' : undefined }}
                            value={s.modelo || ''}
                            onChange={(e) => atualizarSituacaoFmp(s.id, 'modelo', e.target.value)}
                          >
                            <option value="">-</option>
                            <option value="Demo">Demo</option>
                            <option value="CaaS">CaaS</option>
                          </select>
                        </td>
                        <td>
                          <select
                            className="form-select form-select-sm"
                            style={{ backgroundColor: todosSim ? '#eafbf1' : undefined }}
                            value={s.sistema || ''}
                            onChange={(e) => atualizarSituacaoFmp(s.id, 'sistema', e.target.value)}
                          >
                            <option value="">-</option>
                            <option value="Conta Azul">Conta Azul</option>
                            <option value="Omie">Omie</option>
                            <option value="Super Logica">Super Lógica</option>
                          </select>
                        </td>
                        {['chave_api', 'entregue_operador'].map((campo) => (
                          <td key={campo}>
                            <select
                              className="form-select form-select-sm"
                              style={{ color: s[campo] === 'Sim' ? '#198754' : '#dc3545', fontWeight: 600, backgroundColor: todosSim ? '#eafbf1' : undefined }}
                              value={s[campo] || 'Não'}
                              onChange={(e) => atualizarSituacaoFmp(s.id, campo, e.target.value)}
                            >
                              <option value="Sim">Sim</option>
                              <option value="Não">Não</option>
                            </select>
                          </td>
                        ))}
                        <td>{s.data_entrega || '-'}</td>
                        <td>
                          {todosSim ? (
                            <span className="text-muted">-</span>
                          ) : (() => {
                            const dias = calcularDiasPendente(s.data_entrega);
                            if (dias === null) return <span className="text-muted">-</span>;
                            const cor = dias > 30 ? '#dc3545' : dias > 14 ? '#e67e22' : '#6c757d';
                            return (
                              <span style={{ color: cor, fontWeight: 700 }} title={`Entregue em ${s.data_entrega}`}>
                                {dias} {dias === 1 ? 'dia' : 'dias'}
                              </span>
                            );
                          })()}
                        </td>
                        {['reuniao_apresentacao', 'cliente_com_acesso', 'envio_posicao', 'envio_fechamento'].map((campo) => (
                          <td key={campo}>
                            <select
                              className="form-select form-select-sm"
                              style={{ color: s[campo] === 'Sim' ? '#198754' : '#dc3545', fontWeight: 600, backgroundColor: todosSim ? '#eafbf1' : undefined }}
                              value={s[campo] || 'Não'}
                              onChange={(e) => atualizarSituacaoFmp(s.id, campo, e.target.value)}
                            >
                              <option value="Sim">Sim</option>
                              <option value="Não">Não</option>
                            </select>
                          </td>
                        ))}
                        <td className="text-start">
                          {temDevolutiva ? (
                            <button
                              className="btn btn-sm btn-outline-primary"
                              onClick={() => abrirModalDevolutiva(s)}
                              title="Ver devolutiva do cliente"
                            >
                              <i className="fas fa-eye me-1"></i>
                              Ver
                            </button>
                          ) : (
                            <textarea
                              className="form-control form-control-sm"
                              rows={2}
                              style={{ minWidth: '240px', backgroundColor: todosSim ? '#eafbf1' : undefined }}
                              value={devolutivasRascunho[s.id] !== undefined ? devolutivasRascunho[s.id] : ''}
                              onChange={(e) => handleDevolutivaChange(s.id, e.target.value)}
                              onBlur={() => salvarDevolutiva(s.id)}
                              placeholder="Escreva a devolutiva do cliente..."
                            />
                          )}
                        </td>
                        <td>
                          <button
                            className="btn btn-sm btn-outline-danger"
                            onClick={() => deletarSituacaoFmp(s.id, s.nome)}
                            title="Remover registro"
                          >
                            <i className="fas fa-trash"></i>
                          </button>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            )}
          </div>
        </div>
      </div>

      {/* Modal Cadastro/Edição */}
      {modalAberto && (
        <>
          <div className="modal-overlay" onClick={fecharModal}></div>
          <div className="modal-custom bpo-page-modal">
            <div className="modal-container">
              <div className="modal-header">
                <h5 className="modal-title mb-0 fw-bold">
                  <i className="fas fa-user me-2"></i>
                  {editando ? 'Editar Cliente' : 'Novo Cliente'}
                </h5>
                <button className="btn-close" onClick={fecharModal}></button>
              </div>

              <div className="modal-body">
                <div className="row g-3">
                  <div className="col-12">
                    <h6 className="border-bottom pb-2 mb-3">
                      <i className="fas fa-building me-2"></i>
                      Dados da Empresa
                    </h6>
                  </div>

                  <div className="col-md-8">
                    <label className="form-label">Nome da Empresa *</label>
                    <input
                      type="text"
                      className="form-control"
                      value={formData.nome}
                      onChange={(e) => setFormData({ ...formData, nome: e.target.value })}
                      placeholder="Nome do cliente"
                      maxLength={50}
                    />
                  </div>

                  <div className="col-md-4">
                    <label className="form-label">CNPJ *</label>
                    <input
                      type="text"
                      className="form-control"
                      value={formData.cnpj}
                      onChange={handleCNPJChange}
                      placeholder="00.000.000/0000-00"
                    />
                  </div>

                  <div className="col-md-6">
                    <label className="form-label">Email do Cliente</label>
                    <input
                      type="text"
                      className="form-control"
                      value={formData.email}
                      onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                      placeholder="email@empresa.com.br; outro@email.com.br"
                    />
                    <small className="text-muted">
                      <i className="fas fa-info-circle me-1"></i>
                      Use ponto e vírgula (;) para separar múltiplos emails
                    </small>
                  </div>

                  <div className="col-md-6">
                    <label className="form-label">Email da Contabilidade</label>
                    <input
                      type="text"
                      className="form-control"
                      value={formData.email_contabilidade}
                      onChange={(e) => setFormData({ ...formData, email_contabilidade: e.target.value })}
                      placeholder="contabil@empresa.com.br; contador@email.com.br"
                    />
                    <small className="text-muted">
                      <i className="fas fa-info-circle me-1"></i>
                      Use ponto e vírgula (;) para separar múltiplos emails
                    </small>
                  </div>

                  <div className="col-md-6">
                    <label className="form-label">Email Fiscal (envio de notas)</label>
                    <input
                      type="text"
                      className="form-control"
                      value={formData.email_fiscal}
                      onChange={(e) => setFormData({ ...formData, email_fiscal: e.target.value })}
                      placeholder="fiscal@empresa.com.br; analista@email.com.br"
                    />
                    <small className="text-muted">
                      <i className="fas fa-info-circle me-1"></i>
                      Destinatário do Envio de Notas Fiscais. Se vazio, usa o Email da Contabilidade.
                    </small>
                  </div>

                  <div className="col-md-4">
                    <label className="form-label">Regime Tributário</label>
                    <select
                      className="form-select"
                      value={formData.regime_tributario}
                      onChange={(e) => setFormData({ ...formData, regime_tributario: e.target.value })}
                    >
                      <option value="">Selecione...</option>
                      <option value="Simples Nacional">Simples Nacional</option>
                      <option value="Lucro Presumido">Lucro Presumido</option>
                      <option value="Lucro Real">Lucro Real</option>
                      <option value="MEI">MEI</option>
                    </select>
                  </div>

                  <div className="col-md-4">
                    <label className="form-label">Mensalidade *</label>
                    <input
                      type="number"
                      className="form-control"
                      value={formData.mensalidade}
                      onChange={(e) => setFormData({ ...formData, mensalidade: e.target.value })}
                      placeholder="0"
                      min="0"
                      step="0.01"
                    />
                  </div>

                  <div className="col-md-4">
                    <label className="form-label">Status *</label>
                    <select
                      className="form-select"
                      value={formData.ativo}
                      onChange={(e) => setFormData({ ...formData, ativo: e.target.value })}
                    >
                      <option value="Sim">Ativo</option>
                      <option value="Não">Inativo</option>
                    </select>
                  </div>

                  <div className="col-md-12">
                    <label className="form-label">
                      <i className="fab fa-google-drive me-1 text-warning"></i>
                      Link Google Drive
                    </label>
                    <input
                      type="url"
                      className="form-control"
                      value={formData.link_drive}
                      onChange={(e) => setFormData({ ...formData, link_drive: e.target.value })}
                      placeholder="https://drive.google.com/..."
                    />
                  </div>

                  <div className="col-12 mt-4">
                    <h6 className="border-bottom pb-2 mb-3">
                      <i className="fas fa-user-tie me-2"></i>
                      Operadores Responsáveis
                    </h6>
                  </div>

                  <div className="col-md-6">
                    <label className="form-label">Operador Principal</label>
                    <select
                      className="form-select"
                      value={formData.nome_operador}
                      onChange={(e) => setFormData({ ...formData, nome_operador: e.target.value })}
                    >
                      <option value="">Selecione...</option>
                      {operadores.map(op => (
                        <option key={op.id} value={op.nome}>{op.nome}</option>
                      ))}
                    </select>
                  </div>

                  <div className="col-md-6">
                    <label className="form-label">Operador DP</label>
                    <select
                      className="form-select"
                      value={formData.operador_dp}
                      onChange={(e) => setFormData({ ...formData, operador_dp: e.target.value })}
                    >
                      <option value="">Selecione...</option>
                      <option value="Sem DP">Sem DP</option>
                      {operadores.map(op => (
                        <option key={op.id} value={op.nome}>{op.nome}</option>
                      ))}
                    </select>
                  </div>

                  <div className="col-md-6">
                    <label className="form-label">Operador Contábil</label>
                    <select
                      className="form-select"
                      value={formData.operador_contabil}
                      onChange={(e) => setFormData({ ...formData, operador_contabil: e.target.value })}
                    >
                      <option value="">Selecione...</option>
                      <option value="Sem contabil">Sem contábil</option>
                      {operadores.map(op => (
                        <option key={op.id} value={op.nome}>{op.nome}</option>
                      ))}
                    </select>
                  </div>

                  <div className="col-md-6">
                    <label className="form-label">Operador Fiscal</label>
                    <select
                      className="form-select"
                      value={formData.operador_fiscal}
                      onChange={(e) => setFormData({ ...formData, operador_fiscal: e.target.value })}
                    >
                      <option value="">Selecione...</option>
                      <option value="Sem Fiscal">Sem Fiscal</option>
                      {operadores.map(op => (
                        <option key={op.id} value={op.nome}>{op.nome}</option>
                      ))}
                    </select>
                  </div>

                  <div className="col-12 mt-4">
                    <h6 className="border-bottom pb-2 mb-3">
                      <i className="fas fa-cogs me-2"></i>
                      Configurações do Sistema
                    </h6>
                  </div>

                  <div className="col-md-4">
                    <label className="form-label">Sistema</label>
                    <select
                      className="form-select"
                      value={formData.sistema}
                      onChange={(e) => setFormData({ ...formData, sistema: e.target.value })}
                    >
                      <option value="">Selecione...</option>
                      <option value="conta_azul">Conta Azul</option>
                      <option value="omie">Omie</option>
                      <option value="default">Padrão</option>
                    </select>
                  </div>

                  <div className="col-md-4">
                    <label className="form-label">Tipo de Plano</label>
                    <select
                      className="form-select"
                      value={formData.tipo_plano}
                      onChange={(e) => setFormData({ ...formData, tipo_plano: e.target.value })}
                    >
                      <option value="">Selecione...</option>
                      <option value="Premium">Premium</option>
                      <option value="Demo">Demo</option>
                    </select>
                  </div>

                  <div className="col-md-4">
                    <label className="form-label">Dia Posição</label>
                    <select
                      className="form-select"
                      value={formData.dia_posicao}
                      onChange={(e) => setFormData({ ...formData, dia_posicao: e.target.value })}
                    >
                      <option value="">Selecione...</option>
                      <option value="Segunda-feira">Segunda-feira</option>
                      <option value="Terça-feira">Terça-feira</option>
                      <option value="Quarta-feira">Quarta-feira</option>
                      <option value="Quinta-feira">Quinta-feira</option>
                      <option value="Sexta-feira">Sexta-feira</option>
                      <option value="Sábado">Sábado</option>
                      <option value="Domingo">Domingo</option>
                    </select>
                    <small className="text-muted">Dia da semana para envio da posição</small>
                  </div>

                  <div className="col-md-4">
                    <label className="form-label">Dia Fechamento</label>
                    <input
                      type="number"
                      className="form-control"
                      value={formData.dia_fechamento}
                      onChange={(e) => setFormData({ ...formData, dia_fechamento: e.target.value })}
                      placeholder="Ex: 10"
                      min="1"
                      max="31"
                    />
                    <small className="text-muted">Dia do mês para envio do fechamento</small>
                  </div>

                  <div className="col-md-4">
                    <label className="form-label">Database</label>
                    <input
                      type="password"
                      className="form-control"
                      value={formData.database}
                      onChange={(e) => setFormData({ ...formData, database: e.target.value })}
                      placeholder="Nome do banco de dados"
                      maxLength={100}
                    />
                  </div>

                  <div className="col-md-6">
                    <label className="form-label">ID Empresa (Conta Azul)</label>
                    <input
                      type="password"
                      className="form-control"
                      value={formData.id_empresa_ca}
                      onChange={(e) => setFormData({ ...formData, id_empresa_ca: e.target.value })}
                      placeholder="ID da empresa no sistema"
                      maxLength={100}
                    />
                  </div>

                  <div className="col-md-6">
                    <label className="form-label">URL de Atualização</label>
                    <input
                      type="password"
                      className="form-control"
                      value={formData.url_atualizacao}
                      onChange={(e) => setFormData({ ...formData, url_atualizacao: e.target.value })}
                      placeholder="https://..."
                    />
                  </div>

                  <div className="col-md-6">
                    <label className="form-label">API Key</label>
                    <input
                      type="password"
                      className="form-control"
                      value={formData.apikey}
                      onChange={(e) => setFormData({ ...formData, apikey: e.target.value })}
                      placeholder="Chave de API"
                    />
                  </div>

                  <div className="col-md-6">
                    <label className="form-label">API Secret</label>
                    <input
                      type="password"
                      className="form-control"
                      value={formData.apisecredty}
                      onChange={(e) => setFormData({ ...formData, apisecredty: e.target.value })}
                      placeholder="Secret de API"
                    />
                  </div>

                  <div className="col-12 mt-4">
                    <h6 className="border-bottom pb-2 mb-1">
                      <i className="fas fa-lock me-2"></i>
                      Credenciais do Operador
                    </h6>
                    <small className="text-muted mb-3 d-block">
                      <i className="fas fa-info-circle me-1"></i>
                      Qual operador sai os Emails
                    </small>
                  </div>

                  <div className="col-md-12">
                    <label className="form-label">Operador de envio</label>
                    <div className="input-group">
                      <select
                        className="form-select"
                        value={formData.operador_bpo_id || ''}
                        onChange={(e) => setFormData({ ...formData, operador_bpo_id: e.target.value })}
                      >
                        <option value="">— nenhum (não envia e-mail) —</option>
                        {operadoresEnvio.filter((o) => o.ativo === 'Sim' || String(o.id) === String(formData.operador_bpo_id)).map((o) => (
                          <option key={o.id} value={o.id}>
                            {o.nome} ({o.email}){o.tem_senha ? '' : ' — SEM SENHA'}
                            {o.ativo !== 'Sim' ? ' — inativo' : ''}
                          </option>
                        ))}
                      </select>
                      <button
                        type="button"
                        className="btn btn-outline-secondary"
                        onClick={() => { carregarOperadoresEnvio(); setModalOperadores(true); }}
                        title="Cadastrar ou editar operadores de envio"
                      >
                        <i className="fas fa-gear"></i>
                      </button>
                    </div>
                    <small className="text-muted">
                      A senha de app fica no cadastro do operador. Para trocar quem envia,
                      basta escolher outro nome aqui.
                    </small>
                  </div>

                </div>
              </div>

              <div className="modal-footer">
                <button
                  className="btn btn-secondary"
                  onClick={fecharModal}
                >
                  <i className="fas fa-times me-2"></i>
                  Cancelar
                </button>
                <button
                  className="btn btn-primary"
                  onClick={salvarCliente}
                  disabled={carregando}
                >
                  <i className="fas fa-save me-2"></i>
                  {carregando ? 'Salvando...' : 'Salvar'}
                </button>
              </div>
            </div>
          </div>
        </>
      )}

      {/* Modal Visualizar Cliente */}
      {modalVisualizarAberto && clienteSelecionado && (
        <>
          <div className="modal-overlay" onClick={fecharModalVisualizar}></div>
          <div className="modal-custom bpo-page-modal">
            <div className="modal-container">
              <div className="modal-header" style={{ backgroundColor: '#ffffff', borderBottom: '1px solid #e9ecef' }}>
                <h5 className="modal-title mb-0 fw-bold" style={{ color: '#212529' }}>
                  <i className="fas fa-eye me-2"></i>
                  Dados do Cliente
                </h5>
                <button className="btn-close" onClick={fecharModalVisualizar}></button>
              </div>

              <div className="modal-body">
                <div className="row g-3">
                  <div className="col-12">
                    <h6 className="border-bottom pb-2 mb-3 text-primary">
                      <i className="fas fa-building me-2"></i>
                      Dados da Empresa
                    </h6>
                  </div>

                  <div className="col-md-8">
                    <label className="form-label text-muted small">Nome da Empresa</label>
                    <p className="fw-bold mb-0">{clienteSelecionado.nome}</p>
                  </div>

                  <div className="col-md-4">
                    <label className="form-label text-muted small">CNPJ</label>
                    <p className="fw-bold mb-0">{formatarCNPJ(clienteSelecionado.cnpj)}</p>
                  </div>

                  <div className="col-md-6">
                    <label className="form-label text-muted small">Email do Cliente</label>
                    <p className="mb-0">{clienteSelecionado.email || '-'}</p>
                  </div>

                  <div className="col-md-6">
                    <label className="form-label text-muted small">Email da Contabilidade</label>
                    <p className="mb-0">{clienteSelecionado.email_contabilidade || '-'}</p>
                  </div>

                  <div className="col-md-6">
                    <label className="form-label text-muted small">Email Fiscal (envio de notas)</label>
                    <p className="mb-0">{clienteSelecionado.email_fiscal || '-'}</p>
                  </div>

                  <div className="col-md-4">
                    <label className="form-label text-muted small">Regime Tributário</label>
                    <p className="mb-0">{clienteSelecionado.regime_tributario || '-'}</p>
                  </div>

                  <div className="col-md-4">
                    <label className="form-label text-muted small">Mensalidade</label>
                    <p className="fw-bold text-success mb-0">
                      R$ {parseFloat(clienteSelecionado.mensalidade || 0).toLocaleString('pt-BR', {minimumFractionDigits: 2})}
                    </p>
                  </div>

                  <div className="col-md-4">
                    <label className="form-label text-muted small">Status</label>
                    <p className="mb-0">
                      <span className={`badge ${clienteSelecionado.ativo === 'Sim' ? 'bg-success' : 'bg-danger'}`}>
                        {clienteSelecionado.ativo === 'Sim' ? 'Ativo' : 'Inativo'}
                      </span>
                    </p>
                  </div>

                  <div className="col-md-12">
                    <label className="form-label text-muted small">
                      <i className="fab fa-google-drive me-1 text-warning"></i>
                      Link Google Drive
                    </label>
                    {clienteSelecionado.link_drive ? (
                      <p className="mb-0">
                        <a href={clienteSelecionado.link_drive} target="_blank" rel="noopener noreferrer" className="text-primary">
                          <i className="fas fa-external-link-alt me-1"></i>
                          Abrir pasta do cliente
                        </a>
                      </p>
                    ) : (
                      <p className="text-muted mb-0">-</p>
                    )}
                  </div>

                  <div className="col-12 mt-3">
                    <h6 className="border-bottom pb-2 mb-3 text-primary">
                      <i className="fas fa-user-tie me-2"></i>
                      Operadores Responsáveis
                    </h6>
                  </div>

                  <div className="col-md-6">
                    <label className="form-label text-muted small">Operador Principal</label>
                    <p className="mb-0">{clienteSelecionado.nome_operador || '-'}</p>
                  </div>

                  <div className="col-md-6">
                    <label className="form-label text-muted small">Operador DP</label>
                    <p className="mb-0">{clienteSelecionado.operador_dp || '-'}</p>
                  </div>

                  <div className="col-md-6">
                    <label className="form-label text-muted small">Operador Contábil</label>
                    <p className="mb-0">{clienteSelecionado.operador_contabil || '-'}</p>
                  </div>

                  <div className="col-md-6">
                    <label className="form-label text-muted small">Operador Fiscal</label>
                    <p className="mb-0">{clienteSelecionado.operador_fiscal || '-'}</p>
                  </div>

                  <div className="col-12 mt-3">
                    <h6 className="border-bottom pb-2 mb-3 text-primary">
                      <i className="fas fa-info-circle me-2"></i>
                      Informações Adicionais
                    </h6>
                  </div>

                  <div className="col-md-6">
                    <label className="form-label text-muted small">Data de Cadastro</label>
                    <p className="mb-0">{clienteSelecionado.data_cadastro || '-'}</p>
                  </div>
                </div>
              </div>

              <div className="modal-footer">
                <button
                  className="btn btn-primary"
                  onClick={() => {
                    fecharModalVisualizar();
                    abrirModal(clienteSelecionado);
                  }}
                >
                  <i className="fas fa-edit me-2"></i>
                  Editar
                </button>
                <button
                  className="btn btn-secondary"
                  onClick={fecharModalVisualizar}
                >
                  <i className="fas fa-times me-2"></i>
                  Fechar
                </button>
              </div>
            </div>
          </div>
        </>
      )}
      {/* Modal Gerenciar Módulos */}
      {modalModulosAberto && clienteModulos && (
        <>
          <div className="modal-overlay" onClick={fecharModalModulos}></div>
          <div className="modal-custom bpo-page-modal">
            <div className="modal-container">
              <div className="modal-header" style={{ backgroundColor: '#ffffff', borderBottom: '1px solid #e9ecef' }}>
                <h5 className="modal-title mb-0 fw-bold" style={{ color: '#212529' }}>
                  <i className="fas fa-th-large me-2"></i>
                  Módulos liberados — {clienteModulos.nome}
                </h5>
                <button className="btn-close" onClick={fecharModalModulos}></button>
              </div>

              <div className="modal-body">
                <div className="d-flex justify-content-between align-items-center mb-3 flex-wrap gap-2">
                  <small className="text-muted">
                    <i className="fas fa-info-circle me-1"></i>
                    Os módulos marcados como <strong>Sim</strong> aparecem no painel deste cliente.
                  </small>
                  <div className="d-flex gap-2">
                    <button className="btn btn-sm btn-outline-success" onClick={() => definirTodosModulos('Sim')}>
                      Marcar todos
                    </button>
                    <button className="btn btn-sm btn-outline-secondary" onClick={() => definirTodosModulos('Não')}>
                      Desmarcar todos
                    </button>
                  </div>
                </div>

                <div className="row g-2">
                  {MODULOS.map(m => {
                    const ativo = modulosForm[m.key] === 'Sim';
                    return (
                      <div className="col-md-6" key={m.key}>
                        <div
                          className="d-flex align-items-center justify-content-between p-2 rounded border"
                          style={{
                            cursor: 'pointer',
                            background: ativo ? '#e8f5ee' : '#f8f9fa',
                            borderColor: ativo ? '#1f9d6b' : '#dee2e6'
                          }}
                          onClick={() => toggleModulo(m.key)}
                        >
                          <span className="d-flex align-items-center gap-2">
                            <i className={`fas ${m.icon}`} style={{ color: ativo ? '#1f7a52' : '#9aa1ad', width: '18px', textAlign: 'center' }}></i>
                            <span style={{ fontWeight: 600, color: ativo ? '#1f7a52' : '#6c757d' }}>{m.label}</span>
                          </span>
                          <div className="form-check form-switch m-0">
                            <input
                              className="form-check-input"
                              type="checkbox"
                              checked={ativo}
                              onChange={() => toggleModulo(m.key)}
                              onClick={(e) => e.stopPropagation()}
                              style={{ cursor: 'pointer' }}
                            />
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>

              <div className="modal-footer">
                <button className="btn btn-secondary" onClick={fecharModalModulos}>
                  <i className="fas fa-times me-2"></i>
                  Cancelar
                </button>
                <button className="btn btn-primary" onClick={salvarModulos} disabled={salvandoModulos}>
                  <i className="fas fa-save me-2"></i>
                  {salvandoModulos ? 'Salvando...' : 'Salvar Módulos'}
                </button>
              </div>
            </div>
          </div>
        </>
      )}

      {/* Modal Devolutiva do Cliente */}
      {modalDevolutivaAberto && devolutivaSelecionada && (
        <>
          <div className="modal-overlay" onClick={fecharModalDevolutiva}></div>
          <div className="modal-custom bpo-page-modal">
            <div className="modal-container">
              <div className="modal-header" style={{ backgroundColor: '#ffffff', borderBottom: '1px solid #e9ecef' }}>
                <h5 className="modal-title mb-0 fw-bold" style={{ color: '#212529' }}>
                  <i className="fas fa-comment-dots me-2"></i>
                  Devolutiva do Cliente — {devolutivaSelecionada.nome}
                </h5>
                <button className="btn-close" onClick={fecharModalDevolutiva}></button>
              </div>

              <div className="modal-body">
                <label className="form-label text-muted small">
                  <i className="fas fa-info-circle me-1"></i>
                  Você pode editar o texto abaixo e salvar.
                </label>
                <textarea
                  className="form-control"
                  rows={6}
                  value={devolutivaSelecionada.texto}
                  onChange={(e) => setDevolutivaSelecionada(prev => ({ ...prev, texto: e.target.value }))}
                  placeholder="Escreva a devolutiva do cliente..."
                />
              </div>

              <div className="modal-footer">
                <button className="btn btn-secondary" onClick={fecharModalDevolutiva}>
                  <i className="fas fa-times me-2"></i>
                  Fechar
                </button>
                <button className="btn btn-primary" onClick={salvarDevolutivaModal} disabled={salvandoDevolutivaModal}>
                  <i className="fas fa-save me-2"></i>
                  {salvandoDevolutivaModal ? 'Salvando...' : 'Salvar'}
                </button>
              </div>
            </div>
          </div>
        </>
      )}

      {/* ===== Operadores de envio ===== */}
      {modalOperadores && (
        <div className="modal d-block bpo-page-modal" tabIndex="-1" style={{ backgroundColor: 'rgba(0,0,0,.5)' }}>
          <div className="modal-dialog modal-lg modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <div>
                  <h5 className="modal-title" style={{ color: '#212529' }}>
                    <i className="fas fa-paper-plane me-2"></i>Operadores de envio
                  </h5>
                  <small style={{ color: '#6c757d' }}>
                    A caixa que assina os e-mails. Cadastre uma vez e reaproveite em todos os clientes.
                  </small>
                </div>
                <button type="button" className="btn-close"
                  onClick={() => { setModalOperadores(false); setFormOperador({ id: null, nome: '', email: '', senha_app: '', ativo: 'Sim', observacao: '' }); }}></button>
              </div>

              <div className="modal-body">
                <div className="row g-2 align-items-end mb-3">
                  <div className="col-md-3">
                    <label className="form-label small fw-semibold mb-1">Nome</label>
                    <input className="form-control form-control-sm" value={formOperador.nome}
                      onChange={(e) => setFormOperador({ ...formOperador, nome: e.target.value })}
                      placeholder="Karine Barcellos" />
                  </div>
                  <div className="col-md-4">
                    <label className="form-label small fw-semibold mb-1">E-mail</label>
                    <input type="email" className="form-control form-control-sm" value={formOperador.email}
                      onChange={(e) => setFormOperador({ ...formOperador, email: e.target.value })}
                      placeholder="nome@comecehub.com.br" />
                  </div>
                  <div className="col-md-3">
                    <label className="form-label small fw-semibold mb-1">Senha de app</label>
                    <input type="password" className="form-control form-control-sm" value={formOperador.senha_app}
                      onChange={(e) => setFormOperador({ ...formOperador, senha_app: e.target.value })}
                      placeholder={formOperador.id ? 'deixe vazio p/ manter' : 'senha de app do Gmail'} />
                  </div>
                  <div className="col-md-2 d-flex gap-1">
                    <button className="btn btn-sm btn-primary flex-grow-1" onClick={salvarOperadorEnvio} disabled={salvandoOperador}>
                      <i className={`fas ${formOperador.id ? 'fa-check' : 'fa-plus'} me-1`}></i>
                      {formOperador.id ? 'Salvar' : 'Add'}
                    </button>
                    {formOperador.id && (
                      <button className="btn btn-sm btn-outline-secondary" title="Cancelar edição"
                        onClick={() => setFormOperador({ id: null, nome: '', email: '', senha_app: '', ativo: 'Sim', observacao: '' })}>
                        <i className="fas fa-xmark"></i>
                      </button>
                    )}
                  </div>
                </div>

                <div className="alert alert-light border py-2 mb-3">
                  <small className="text-muted">
                    <i className="fas fa-shield-halved me-1"></i>
                    A senha de app nunca é devolvida pela API. Ao editar, o campo vazio mantém a senha atual.
                  </small>
                </div>

                <div className="table-responsive">
                  <table className="table table-sm table-hover align-middle mb-0">
                    <thead className="table-light">
                      <tr>
                        <th>Nome</th>
                        <th>E-mail</th>
                        <th className="text-center">Senha</th>
                        <th className="text-center">Clientes</th>
                        <th className="text-center">Ativo</th>
                        <th className="text-end">Ações</th>
                      </tr>
                    </thead>
                    <tbody>
                      {operadoresEnvio.length === 0 && (
                        <tr><td colSpan={6} className="text-center text-muted py-3">
                          Nenhum operador cadastrado ainda.
                        </td></tr>
                      )}
                      {operadoresEnvio.map((o) => (
                        <tr key={o.id}>
                          <td><strong>{o.nome}</strong></td>
                          <td className="text-muted">{o.email}</td>
                          <td className="text-center">
                            {o.tem_senha
                              ? <span className="badge bg-success-subtle text-success">definida</span>
                              : <span className="badge bg-danger-subtle text-danger">falta</span>}
                          </td>
                          <td className="text-center">{o.clientes}</td>
                          <td className="text-center">
                            {o.ativo === 'Sim'
                              ? <span className="badge bg-primary-subtle text-primary">Sim</span>
                              : <span className="badge bg-secondary-subtle text-secondary">Não</span>}
                          </td>
                          <td className="text-end">
                            <button className="btn btn-sm btn-outline-primary me-1" title="Editar"
                              onClick={() => setFormOperador({ id: o.id, nome: o.nome, email: o.email, senha_app: '', ativo: o.ativo, observacao: o.observacao || '' })}>
                              <i className="fas fa-pen"></i>
                            </button>
                            <button className="btn btn-sm btn-outline-danger" title="Remover"
                              onClick={() => removerOperadorEnvio(o)} disabled={o.clientes > 0}>
                              <i className="fas fa-trash"></i>
                            </button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>

              <div className="modal-footer">
                <button className="btn btn-secondary"
                  onClick={() => { setModalOperadores(false); setFormOperador({ id: null, nome: '', email: '', senha_app: '', ativo: 'Sim', observacao: '' }); }}>
                  <i className="fas fa-times me-2"></i>Fechar
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

    </div>
  );
};

export default ClientesBpo;
